export default class SegmentAnalytics {
  
  static customEvent(action: string) {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track) {
      segmentAnalytics.track(action);
    }
  }

  static loggedIn(uniqueId: string, userEmail: string) {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track && segmentAnalytics.identify) {
      segmentAnalytics.identify(uniqueId, {
        email: userEmail,
      });

      segmentAnalytics.track('Logged In');
    }
  }

  static findARetailer(url: String) {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track) {
      segmentAnalytics.track('Find a Retailer');
    }
  }

  static printRecommendations() {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track) {
      segmentAnalytics.track('Print Recommendations');
    }
  }

  static innerSectionVisit(category: string, name: string) {
    /* Via Segment Docs:
    /   category: The category of the page. Useful for things like ecommerce where many pages often live under a larger category.
    /   name: The name of the page, for example Signup or Home.
    */
   (window as any).currentPageName = category;
   const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.page) {
      segmentAnalytics.page(category, name);
    }
  }
}
